export default "__VITE_ASSET__BniWq4iG__"